var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "SuccessTrade success-trade" }, [
    _c("div", { staticClass: "success-container" }, [
      _c("img", { attrs: { src: "/img/success.png", alt: "" } }),
      _vm._v(" "),
      _c("h2", [_vm._v("Special trade successfully created!")]),
      _vm._v(" "),
      _c("div", { staticClass: "button-holder" }, [
        _c(
          "button",
          {
            staticClass: "btn",
            on: {
              click: function ($event) {
                return _vm.backToList()
              },
            },
          },
          [_vm._v("Back to the list")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn",
            on: {
              click: function ($event) {
                return _vm.viewTrade()
              },
            },
          },
          [_vm._v("View trade")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }